import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BusinessAccountFeature } from "../models/BusinessAccountFeature.model";
import { features as accountFeatures } from "../mockData/BusinessAccountFeatures";
import { setAccountOpeningStep } from "../redux/accountOpening";
import { useSelector } from "react-redux";

function BusinessTypeInfo(props: any) {
  const navigate = useNavigate();
  const [accountDetails, setAccountDetails] =
    useState<BusinessAccountFeature>();

  const { accountOpeningStep } = useSelector(
    (state: any) => state.accountOpeningData
  );

  const setAccountTypeToDisplay = () => {
    switch (props.accountType) {
      case "Business account":
        setAccountDetails(accountFeatures.BusinessDetails);
        break;
      case "Company account":
        setAccountDetails(accountFeatures.CompanyDetails);
        break;
    }
  };

  useEffect(() => {
    setAccountTypeToDisplay();
    // },[])
  }, []);


  const navigateToOpenAccount = () => {
    if (props.accountType === "Company account") {
      navigate("/open-company-account");
    } else if (props.accountType === "Business account") {
      navigate("/open-business-account");
    }

    // setAccountOpeningStep("tin-validation");
  };

  useEffect(() => {
    setAccountTypeToDisplay();
    // },[])
  }, [props]);

  return (
    <div>
      <div>
        <div className=" row mx-auto  bg-transparent mt-4  p-2 displayTray-title ">
          <div className="col-lg-4 p-2 text-lg-left medium-bold-texts text-capitalize">
            {props.accountType}
          </div>
          <div className="col-lg-4 py-md-3">
            <button
              className="btn btn-filled-red mt-2  float-lg-right  text-nowrap"
              onClick={navigateToOpenAccount}
            >
              Get Started
            </button>
          </div>
        </div>
        <div className="row mx-auto d-flex justify-content-between d-md-none d-lg-flex">
          <article className="col-lg-6 display-Tray px-0 mt-4">
            <div className=" small-label-texts text-lg-left">Features</div>

            {accountDetails
              ? accountDetails.features.map((feature) => {
                  return (
                    <div
                      key={feature.id}
                      className=" small-light-texts text-lg-left py-2"
                    >
                      <span className="bullets mr-1"></span> {feature.text}
                    </div>
                  );
                })
              : null}
          </article>
          <article className="col-lg-6 px-0 mt-4">
            <div className=" small-label-texts text-lg-left">Requirements</div>
            {accountDetails
              ? accountDetails.requirements.map((requirement) => {
                  return (
                    <div
                      key={requirement.id}
                      className=" small-light-texts text-lg-left py-2"
                    >
                      <span className="bullets mr-1"></span> {requirement.text}
                    </div>
                  );
                })
              : null}
          </article>
        </div>
      </div>
    </div>
  );
}

export default BusinessTypeInfo;
